import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import api from "../api/client.js";
import { useI18n } from "../i18n/I18nContext.jsx";

const ROLES = [
  "SUPER_ADMIN", "CORP_ADMIN", "ZONAL_AC", "DEPT_HEAD",
  "OFFICER", "AUDITOR", "VIEWER",
];

export default function OfficerForm({ officer, onClose, onDone }) {
  const { t } = useI18n();
  const [zones, setZones] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const isEdit = !!officer;

  const [form, setForm] = useState(
    officer || {
      mobile: "", full_name: "", role: "OFFICER", designation: "",
      department: "", zone: "", password: "audit@123",
    }
  );

  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    api.get("/zones/").then((r) => setZones(r.data.results || r.data));
    api.get("/departments/").then((r) => setDepartments(r.data.results || r.data));
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const payload = { ...form };
      if (!payload.zone) payload.zone = null;
      if (isEdit && !payload.password) delete payload.password;

      if (isEdit) {
        await api.put(`/auth/users/${officer.id}/`, payload);
      } else {
        await api.post("/auth/users/", payload);
      }
      onDone();
    } catch (err) {
      setError(err.response?.data?.detail || JSON.stringify(err.response?.data || "Failed."));
    } finally {
      setBusy(false);
    }
  };

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 500 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <h2 style={{ margin: 0 }}>{isEdit ? "Edit Officer" : t("addUser")}</h2>
          <button type="button" className="btn btn-outline" style={{ padding: "4px 8px" }} onClick={onClose}>
            &times;
          </button>
        </div>
        
        <form onSubmit={save} className="form-grid">
          {error && <div className="alert alert-error" style={{ gridColumn: "1 / -1" }}>{error}</div>}
          <div className="field">
            <label>{t("fullName")}</label>
            <input value={form.full_name} onChange={set("full_name")} required />
          </div>
          <div className="field">
            <label>{t("mobile")}</label>
            <input value={form.mobile} onChange={set("mobile")} required />
          </div>
          <div className="field">
            <label>{t("role")}</label>
            <select value={form.role} onChange={set("role")}>
              {ROLES.map((r) => (
                <option key={r} value={r}>
                  {r.replace(/_/g, " ")}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>{t("zone")}</label>
            <select value={form.zone || ""} onChange={set("zone")}>
              <option value="">Select Zone</option>
              {zones.map((z) => (
                <option key={z.id} value={z.id}>{z.name}</option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>{t("designation")}</label>
            <input value={form.designation || ""} onChange={set("designation")} />
          </div>
          <div className="field">
            <label>{t("department")}</label>
            <select value={form.department || ""} onChange={set("department")}>
              <option value="">Select Department</option>
              {departments.map((d) => (
                <option key={d.id} value={d.name}>{d.name}</option>
              ))}
            </select>
          </div>

          <div className="field" style={{ gridColumn: "1 / -1" }}>
            <label>{t("password")} {isEdit && <span className="muted" style={{fontSize: 12}}>(Leave blank to keep current)</span>}</label>
            <input value={form.password || ""} onChange={set("password")} placeholder={isEdit ? "********" : "audit@123"} type={isEdit ? "password" : "text"} />
          </div>

          <div className="modal-actions" style={{ gridColumn: "1 / -1" }}>
            <button type="button" className="btn btn-outline" onClick={onClose}>{t("cancel")}</button>
            <button type="submit" className="btn btn-primary" disabled={busy || !form.mobile || !form.full_name}>{t("save")}</button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
